import React, { useState, useMemo } from 'react';
import { Icon } from '@iconify/react';

const formatSize = (bytes) => {
  if (!bytes && bytes !== 0) return '-';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let val = bytes;
  while (val >= 1024 && i < sizes.length - 1) {
    val /= 1024;
    i += 1;
  }
  return `${val.toFixed(1)} ${sizes[i]}`;
};

const DocumentDataTable = ({ files, onDelete, directory = 'assetfiles' }) => {
  const [search, setSearch] = useState('');

  const rows = useMemo(() => {
    const mapped = (files || []).map((f, idx) => {
      const fileObj = typeof f === 'string' ? { name: f, key: f } : f;
      const key = fileObj.key || fileObj.filename;
      const url = fileObj.url || `${process.env.REACT_APP_SPACES_BASE}/${key}`;
      const ext = key?.split('.').pop().toUpperCase() || '';
      let icon = 'file-icons:file';
      let colorClass = '';
      switch (ext.toLowerCase()) {
        case 'pdf':
          icon = 'file-icons:adobe-acrobat';
          colorClass = 'text-danger';
          break;
        case 'doc':
        case 'docx':
          icon = 'file-icons:microsoft-word';
          colorClass = 'text-primary';
          break;
        case 'xls':
        case 'xlsx':
          icon = 'file-icons:microsoft-excel';
          colorClass = 'text-success';
          break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'bmp':
        case 'gif':
        case 'heic':
          icon = 'file-icons:image';
          colorClass = 'text-dark';
          break;
        case 'csv':
          icon = 'iconoir:notes';
          break;
        case 'dwg':
        case 'dxf':
        case 'svg':
          icon = 'file-icons:draw-io';
          colorClass = 'text-dark';
          break;
        default:
          icon = 'file-icons:file';
      }
      return { idx, fileObj, key, url, ext, icon, colorClass };
    });

    if (!search) return mapped;
    const term = search.toLowerCase();
    return mapped.filter(({ fileObj, key, ext }) =>
      fileObj.name.toLowerCase().includes(term) ||
      key.toLowerCase().includes(term) ||
      ext.toLowerCase().includes(term)
    );
  }, [files, search]);

  return (
    <div className="mt-3">
      <input
        type="text"
        className="form-control mb-16"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="table-responsive">
        <table className="table bordered-table mb-0 w-100 rounded-0">
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>Filename</th>
              <th>Size</th>
              <th>Extension</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ idx, fileObj, key, url, ext, icon, colorClass }) => (
              <tr key={idx}>
                <td>
                  <Icon icon={icon} className={`icon text-xl ${colorClass}`} />
                </td>
                <td>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {fileObj.name}
                  </a>
                </td>
                <td>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {key}
                  </a>
                </td>
                <td>{fileObj.size ? formatSize(fileObj.size) : '-'}</td>
                <td>{ext}</td>
                <td>
                  <button
                    className="delete-btn w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    onClick={() => onDelete(key, idx)}
                  >
                    <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                  </button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center">
                  No files found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocumentDataTable;
